var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "aptamer-favorite-container" }, [
    _c(
      "div",
      { staticClass: "item-list" },
      [
        _vm._l(_vm.records, function (item, i) {
          return _c("div", { key: i, staticClass: "item-container" }, [
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "location" }, [
                _c(
                  "a",
                  {
                    staticClass: "entry entry-title",
                    attrs: { href: `/paper/${item.articleID}` },
                  },
                  [_vm._v(" " + _vm._s(item.articleTitle) + " ")]
                ),
                _c("div", { staticClass: "entry" }, [
                  _c("div", [
                    _vm._v(" 作者："),
                    _c("span", { staticStyle: { color: "#3463ea" } }, [
                      _vm._v(_vm._s(item.author)),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "entry" }, [
                  _c("div", [
                    _vm._v(" 杂志名称："),
                    _c("span", { staticStyle: { color: "#3463ea" } }, [
                      _vm._v(_vm._s(item.journal || 0)),
                    ]),
                  ]),
                  _c("div", { staticStyle: { "margin-left": "16px" } }, [
                    _vm._v(" 期刊号："),
                    _c("span", { staticStyle: { color: "#3463ea" } }, [
                      _vm._v(_vm._s(item.issn)),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "entry" }, [
                  _c("div", [
                    _vm._v(
                      " 发表时间：" +
                        _vm._s(
                          _vm._f("dateFormat")(item.publishedDate, "YYYY-MM-DD")
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticStyle: { "margin-left": "16px" } }, [
                    _vm._v(" 引用频次："),
                    _c("span", { staticStyle: { color: "#3463ea" } }, [
                      _vm._v(_vm._s(item.citedCount || 0)),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "entry" }, [
                  _c("div", { staticStyle: { width: "7%" } }, [
                    _vm._v("摘要："),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "textOmitted",
                      staticStyle: { width: "93%" },
                    },
                    [_vm._v(" " + _vm._s(item.abstract) + " ")]
                  ),
                ]),
              ]),
            ]),
          ])
        }),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                id: "pagination",
                "current-page": _vm.pager.index,
                "page-sizes": [10, 25, 50],
                "page-size": _vm.pager.size,
                layout: "prev, pager, next, jumper, sizes",
                total: _vm.total,
              },
              on: {
                "current-change": _vm.query,
                "size-change": _vm.sizeChange,
              },
            }),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }